
import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext'
import { useEffect} from 'react'

import "./aitest.css"

export const College = ({university, country, language, progress, active}) => {

   let {
      saveTestLanguage,
      saveTestUniversity,
      saveTestCountry,
      onSelectUniversity,

      setUniversityIndex,
      getUniversityIndex,
      setCollegeIndex,
   
  } = React.useContext(AITestContext);

    let {
      setTestLanguage,
      setMainLanguage,
  } = React.useContext(StatusContext);


  useEffect(() => {
    console.log("useEffect: College")
  }, []);

  const handleOnClick = () => {
    console.log("Univeristy: handleOnClick:", active, university, country, language)
    
      

    if (active === true)
    {
      saveTestUniversity(university)
      saveTestCountry(country)
      saveTestLanguage(language)
      setTestLanguage(language)
      setMainLanguage(language)

      setUniversityIndex(getUniversityIndex(university))
      setCollegeIndex(0)
     
      onSelectUniversity()
    }
  }

  return (
      <div className= {active ? "collegeButtonsContainer" : "collegeButtonsContainerDisabled"} onClick = {handleOnClick}>
        <div style={{fontSize:'20px'}}>{university}</div>
        <div>{country}</div>
        <div style={{fontSize:'12px'}}>{progress}</div>
      </div>
  )
}
